function ExceptionError({ name, message }) {
  return { name, message };
}

const api = async ({ method, path, params }) => {
  const opts = {
    method,
    cache: "no-cache",
    headers: {
      "Content-Type": "application/json",
    },
  };

  let url = new URL(path);

  url.searchParams.set('companycode', window.appSettings.companyCode);
  if (window.appSettings.companyCodeVersion) {
    url.searchParams.set('v', window.appSettings.companyCodeVersion);
  }
  if (window.appSettings.language && window.appSettings.language.length) {
    url.searchParams.set('lang', window.appSettings.language);
  }
  if (window.appSettings.isPreview) {
    url.searchParams.set("isPreview", window.appSettings.isPreview);
  }

  switch (method) {
    case "POST":
      opts.body = JSON.stringify(params);
      break;
    case "PUT":
      opts.body = JSON.stringify(params);
      break;
    default:
      break;
  }
  const response = await fetch(url, opts);
  let result;
  switch (response.status) {
    case 200:
      result = await response.json();
      return result;
    case 504:
      throw new ExceptionError({
        name: "Error",
        message: response.statusText,
      });
    default:
      result = await response.json();
      throw result.error;
  }
};

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  POST: (path, params) => api({ method: "POST", path, params }),
  PUT: (path, params) => api({ method: "PUT", path, params }),
};
